import * as Yup from 'yup';

export const validationSchema = Yup.object({
  code: Yup.string()
    .required('Insira o código')
    .min(6, 'Insira o código completo')
    .max(6, 'Insira o código completo'),
});
